import state from './state'
import mutations from './mutations'

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/main.js